/* eslint-disable max-lines-per-function */
import { EventBus, Events } from "jiffy-store";
import { api } from "jiffy-api";
import "./product-details-notify-on-restock-sign-in.scss";

export default () => {
  const $$modal = $(".js-product-details-notify-on-restock-sign-in");
  if (!$$modal.length) return;

  const modalClose = $(".js-product-details-notify-on-restock-sign-in-close");
  const modalForm = $(".js-product-details-notify-on-restock-sign-in-form");
  const errorsContainer = $(".js-product-details-notify-on-restock-sign-in-error");
  const modalOpen = document.querySelectorAll(".js-product-details-notify-on-restock-modal-open");
  const footerButton = document.querySelector(".js-restock-sign-in-footer-button");

  const initModalOpen = buttons => {
    buttons.forEach(btn => {
      const parentBlock = btn.parentElement;
      const { color, productId, businessLineId } = parentBlock.dataset;

      btn.addEventListener("click", async () => {
        $$modal.modal("show");
        $$modal.find("input[type='email']").first().trigger("focus");

        await api.favorites.addFavoriteItem({
          product_slug: productId,
          ac: color,
          notify_state: "subscribed",
          business_line_id: businessLineId
        });
      });
    });
  };

  initModalOpen(modalOpen);

  modalForm.on({
    "ajax:before": () => {
      errorsContainer.hide();
    },
    "ajax:error": (_event, error) => {
      errorsContainer.show().text(JSON.parse(error.responseText).error_message);
    }
  });

  modalClose.on("click", () => {
    errorsContainer.hide();
    $$modal.modal("hide");
  });

  EventBus.on(Events.MOBILE_GRID_LOADED, () => {
    const newModalOpen = document.querySelectorAll(
      ".js-product-details-notify-on-restock-modal-open:not(.inited)"
    );
    initModalOpen(newModalOpen);
  });

  // PIP-3358: on the canonical-URL surface the selected color lives in the
  // #color hash / DOM, not ?ac= — pathname+search alone would redirect the
  // signed-in user back to the default-color PDP. Carry the active color as
  // ?ac= (the server honors it on the post-sign-in redirect).
  const updateRedirectTargets = () => {
    const url = new URL(window.location.pathname + window.location.search, window.location.origin);
    const activeColor = document.getElementById("active-color-name")?.value;
    if (activeColor && !url.searchParams.get("ac")) {
      url.searchParams.set("ac", activeColor);
    }
    const nextPage = encodeURIComponent(url.pathname + url.search);

    footerButton.href = footerButton.href.replace(
      /(next_page=)(.*)(&)/gi,
      `next_page=${nextPage}&`
    );

    modalForm[0].action = modalForm[0].action.replace(
      /(&)(product_redirect=)(.*)/gi,
      `&product_redirect=${nextPage}`
    );
  };

  EventBus.on(Events.PRODUCT_COLOR_SELECTED, updateRedirectTargets);

  // Reconcile on init: a #color hash pre-select can publish PRODUCT_COLOR_SELECTED
  // before this module registers (same registration race the qty-grid loader
  // reconciles — see product-details-load-qty-grid.js). Running once at init
  // picks up whatever color is already active.
  updateRedirectTargets();
};
